import { SVGProps } from 'react';

const SvgAnchorArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 8 22"
    fill="#C8C7CC"
    {...props}
  >
    <path d="M1.274 5 0 6.232 5.45 11.5 0 16.768 1.274 18 8 11.5 1.274 5Z" />
  </svg>
);

export default SvgAnchorArrow;
